<template>
    <div class="garantie-view print-increase-font">
        <template v-if="isBusy">
            <Preloader/>
        </template>
        <template v-else>
            <div class="garantie-view__head">
                <div class="garantie-view__head--title">
                    Attestation en ligne
                </div>
            </div>
            <div class="garantie-view__body">
                <div class="garantie-view__body__block" style="font-size: 0.8em">
                    <div class="garantie-view__body__block--title">
                        RAPPEL DES INFORMATIONS COMMUNIQUÉES
                    </div>

                    <div class="garantie-view__body__block--content"
                         v-if="attestation && attestation.driving_school_car">
                        <div class="title">Votre véhicule :</div>
                        <div class="row">

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label  col-12 col-sm-4">Immatriculation:</div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_car.registration_number}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4">Véhicule:</div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_car.car_brand}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4">Modèle:</div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_car.car_model}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--teacher block-->
                    <div class="garantie-view__body__block--content"
                         v-if="attestation && attestation.driving_school_teacher">
                        <div class="title">Informations sur l'accompagnateur à assurer :</div>

                        <div class="row">

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Nom :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_teacher.first_name}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Prenom :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_teacher.last_name}}
                                    </div>
                                </div>
                            </div>

<!--                            <div class="col-12">-->
<!--                                <div class="field">-->
<!--                                    <div class="field__label col-12 col-sm-4"><b>Addresse :</b></div>-->
<!--                                    <div class="field__value col-12 col-sm-8">-->
<!--                                        {{attestation.driving_school_teacher.address}}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="col-12">-->
<!--                                <div class="field">-->
<!--                                    <div class="field__label col-12 col-sm-4"><b>Code postal :</b></div>-->
<!--                                    <div class="field__value col-12 col-sm-8">-->
<!--                                        {{attestation.driving_school_teacher.zip}}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="col-12">-->
<!--                                <div class="field">-->
<!--                                    <div class="field__label col-12 col-sm-4"><b>Ville :</b></div>-->
<!--                                    <div class="field__value col-12 col-sm-8">-->
<!--                                        {{attestation.driving_school_teacher.city}}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>

                    <!--candidate block-->
                    <div class="garantie-view__body__block--content"
                         v-if="attestation && attestation.driving_school_candidate">
                        <div class="title">Informations sur le candidat :</div>

                        <div class="row">

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Nom :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_candidate.first_name}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Prenom :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_candidate.last_name}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Addresse :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_candidate.address}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Code postal :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_candidate.zip}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Ville :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{attestation.driving_school_candidate.city}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="field">
                                    <div class="field__label col-12 col-sm-4"><b>Date de l'examen :</b></div>
                                    <div class="field__value col-12 col-sm-8">
                                        {{moment(attestation.exam_date).format('DD/MM/YYYY')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="insurance-info row" style="font-size: 1.4em">
                        <div class="insurance-info__buttons col-12 col-sm-8">
                            <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                <div class="insurance-info__buttons--wrapper">
                                    <a href="#" @click.prevent="previousStep" class="blue">
                                        Modifier
                                    </a>
                                    <div class="ball-anchor blue"></div>
                                </div>
                            </div>
                            <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                <div class="insurance-info__buttons--wrapper">
                                    <a href="#" @click.prevent="getPDF()" class="purple">Générer attestation</a>
                                    <div class="ball-anchor purple"></div>
                                </div>
                            </div>
                        </div>
                    </div>

<!--                    <div class="insurance-info row" style="font-size: 1.4em">-->
<!--                        <div class="insurance-info__buttons col-12 col-sm-8">-->
<!--                            <div class="insurance-info__buttons__item insurance-info__buttons__item&#45;&#45;33">-->
<!--                                <div class="col-6 text-right insurance-info__buttons&#45;&#45;wrapper">-->
<!--                                    <a href="#" @click.prenevt="printAttestation" class="green">Imprimer l’attestation</a>-->
<!--                                    <div class="ball-anchor green"></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader'
    import {DRIVING_SCHOOOL_CONST} from "@/driving_school_consts";

    export default {
        name: 'DrivingLicenceAttestationView',
        components: {
            Preloader,
        },
        props: {
            attestation_type: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                attestation: null,
                isBusy: false,
            }
        },
        computed: {

        },
        methods: {
            getAttestationInfo() {
                this.isBusy = true;
                this.apiGet(`driving_school_attestations/${this.$route.params.id}`)
                    .then(response => {
                        this.attestation = response.data;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                    })
                    .finally(() => {
                        this.isBusy = false;
                    })
            },
            getPDF() {
                let url = this.getApiAuthUrl(`driving_school_attestations/pdf/${this.$route.params.id}`);
                console.log(url);
                window.open(url);
                window.location.href = '/double_commande/merci';
            },
            previousStep() {
                switch (this.attestation_type) {
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY:
                        this.$router.push(`/double_commande/double_commande_attestation/${this.$route.params.id}`);
                        break;
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY:
                        this.$router.push(`/double_commande/vtc_attestation/${this.$route.params.id}`);
                        break;
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY:
                        this.$router.push(`/double_commande/bepecaser_attestation/${this.$route.params.id}`);
                        break;
                }
            },
            printAttestation() {
                window.print();
            }
        },
        mounted() {
            this.getAttestationInfo();
            this.$eventBus.$emit('driving-school-sidebar-set-active-tab', this.attestation_type);
        },
        beforeDestroy() {
            this.$eventBus.$emit('driving-school-sidebar-set-active-tab', '');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DrivingSchool/DrivingLicenceAttestation/DrivingLicenceAttestationView.vue